<template>
    <div style="display: inherit; flex-direction: inherit;" v-if="menu && menu.children">
        <div v-if="name === 'MAIN'">
            <v-list>
                <v-list-item-group
                    v-model="selection"
                    color="primary"
                >
                    <smart-nav-item
                        v-for="(link, link_index) in menu.children"
                        :key="link_index"
                        :input="link"
                        :selected="link_index === selection"
                        :current_route="current_route"
                    ></smart-nav-item>
                </v-list-item-group>
            </v-list>
        </div>
        <div style="display: inherit; flex-direction: inherit;" v-else-if="name === 'top'">
            <smart-nav-top-item
                :input="{'name':'HOME','name_route':'home','children':[]}"
                :selected="route().current() === 'home'"
                :current_route="current_route"
                v-show="prepend_home"
                @selection_made="$emit('selection_made')"
            ></smart-nav-top-item>
            <smart-nav-top-item
                v-for="(link, link_index) in menu.children"
                :key="link_index"
                :input="link"
                :selected="link_index === selection"
                :current_route="current_route"
                @selection_made="$emit('selection_made')"
            ></smart-nav-top-item>
        </div>
        <div style="display: inherit; flex-direction: inherit;" v-else-if=" name === 'MEMBERS'">
            <v-expansion-panels flat tile :inset="!$vuetify.breakpoint.mdAndUp" :mandatory="$vuetify.breakpoint.mdAndUp" >
                <v-expansion-panel>
                    <v-expansion-panel-header :color="members_menu_color" v-show="!$vuetify.breakpoint.mdAndUp">MEMBERS</v-expansion-panel-header>
                    <v-expansion-panel-content :color="members_menu_color">
                        <smart-nav-sidebar-item
                            v-for="(link, link_index) in menu.children"
                            :key="link_index"
                            :input="link"
                            :selected="link_index === selection"
                            :current_route="current_route"
                            @selection_made="$emit('selection_made')"
                        ></smart-nav-sidebar-item>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>

            <v-btn v-if="!$vuetify.breakpoint.mdAndUp"
                @click="$inertia.post('logout')"
                class="main-btn tw-mb-7 v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"
            >
                Logout
            </v-btn>
        </div>
    </div>
</template>

<script>
import SmartNavItem from "@/SmartNav/SmartNavItem";
import SmartNavTopItem from "@/SmartNav/SmartNavTopItem.vue";
import {Inertia} from "@inertiajs/inertia";
import SmartNavSidebarItem from "@/SmartNav/SmartNavSidebarItem.vue";
export default {
    name: "SmartNav",
    components: {
        SmartNavSidebarItem,
        SmartNavItem,
        SmartNavTopItem,
    },
    props: {
        'input': {
            // The menu to be displayed
            type: Object,
            required: false,
            default: function () {
                return undefined
            },
        },
        'members_menu': {
            // The menu to be displayed
            type: Object,
            required: false,
            default: function () {
                return undefined
            },
        },
        'name': {
            // The name of the menu to be AJAX-fetched
            type: String,
            required: false,
            default: function () {
                return "EXTERNAL"
            },
        },
        'endpoint': {
            // Specify this url if not passing `input` into this component
            type: String,
            required: false,
            default: function () {
                return 'mymenu'
            },
        },
        'endpoint_method': {
            // Specify this METHOD/VERB if not passing `input` into this component
            type: String,
            required: false,
            default: function () {
                return 'post'
            },
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },

    },
    data () {
        return {
            menu: this.input || null,
            name_local: this.name || null,
            current_route: null,
            selection: null,
            searchTree: (fn) => (obj) =>
                Array.isArray(obj)
                    ? obj.length == 0
                        ? null
                        : this.searchTree (fn) (obj [0]) || this.searchTree (fn) (obj .slice (1))
                    : fn (
                        obj,
                        () => this.searchTree (fn) (obj .children || []),
                        () => obj
                    ),
        }
    },

    computed: {
        prepend_home: function () {
            let current_breakpoint = this.$vuetify.breakpoint.name
            let breakpoints_needing_home = ['xs', 'sm']
            return breakpoints_needing_home.includes(current_breakpoint)
        },
        members_menu_color: function () {
            return this.$vuetify.breakpoint.mdAndUp ? 'rgb(255,0,0,0)' : 'primary'
        },
    },
    mounted() {
        this.init()
    },
    methods:{
        init(force=false) {
            this.fetchMenu(force)
            this.setCurrentRoute()
            this.listenForRouteChanges()
        },
        // Can fetch menu data via AJAX call from endpoint/name props
        async fetchMenu(force=false) {
            if (this.menu && !force) {
                return true
            }
            let url = route(this.endpoint, this.name_local).url()
            axios({
                url:url,
                method:'post'
            }).then((response)=>{
                this.$set(this, 'menu', response.data)
                this.updateSelectedItem()
                this.$emit('menu-updated', this.menu)
            })
        },
        // Will basically prepend icon's name with `mdi-`
        getIconName(partial_name) {
            return partial_name ? `mdi-${partial_name}` : null
        },
        // Search recursively for an id through haystack+children...
        findId(target, haystack) {
            return this.searchTree (
                (node, next, found) => node.id === target ? found () : next(),
            ) (haystack)
        },
        // Search recursively for a route by name through haystack+children...
        findRouteName(target, haystack) {
            return this.searchTree (
                (node, next, found) => node.name_route === target ? found () : next(),
            ) (haystack)
        },
        // Looks up the current route, updates selection too
        setCurrentRoute() {
            this.$set(this, 'current_route', route().current())
            this.updateSelectedItem()
        },
        // An inertia listener that we can use to update the current route whenever partial page reloads happen
        listenForRouteChanges() {
            let test = Inertia.on('success', (event) => {
                // console.log(`The route changed to ${event.detail.page.url}`)
                this.setCurrentRoute()
            })
        },
        // Updates selection with the index of the menu item that should be active
        updateSelectedItem() {
            this.selection = null
            this.menu?.children?.forEach((child, child_index) => {
                let this_is_my_route = !!(this.current_route === child?.name_route)
                let found_in_grandchild_routes = !!(this.findRouteName(this.current_route, child))
                let found_it = this_is_my_route || found_in_grandchild_routes
                if (found_it) {
                    this.selection = child_index
                }
            })
            return this.selection
        },
        updateMenuName(new_menu_name) {
            this.name_local = new_menu_name
            this.init(true)
        },
        getMenuNameByRole(user_role=null) {
            user_role = user_role || this.$root.$page?.user?.role
            let new_menu_name = "EXTERNAL"
            if (["ADMIN", "STAFF"].includes(user_role)) {
                new_menu_name = "INTERNAL"
            }
            return new_menu_name
        },
    },

    watch: {
        name: {
            handler(newVal, oldVal) {
                this.updateMenuName(newVal)
            }
        },
    }
}
</script>

<style scoped>
.v-expansion-panel>>> button {
    padding-left: 18px !important;
}
.v-expansion-panel-content>>> .v-expansion-panel-content__wrap {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}
</style>











